import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import CustomTabPanel from './Components/CustomTabs/CustomTabPanel';
import  a11yProps from './Components/CustomTabs/a11yProps';
import About from './Components/About';


function Settings(){
    const isMobile = useMediaQuery('(max-width:768px)');
    const [settingTab,setSettingTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSettingTab(newValue)
    };

    return (
        <div style={{width: '100%'}} >
            <Box sx={{ width: '100%'}}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, height: '65px' }}>
                {isMobile ? (
                    <div style={{width: '100%', height: '100vh'} }>
                        <Select
                        value={settingTab}
                        onChange={(e) => handleChange(e, e.target.value)}
                        fullWidth
                        size="small"
                        >
                            <MenuItem value={0}>About</MenuItem>
                            <MenuItem value={1}>Email Templates</MenuItem>
                        </Select>
                    </div>
                ) : (
                    <Tabs value={settingTab} onChange={handleChange} >
                        <Tab label="About" {...a11yProps(0)} />
                        <Tab label="Email Templates" {...a11yProps(1)} />
                    </Tabs>
                )}
                </Box>
            </Box>

            <CustomTabPanel value={settingTab} index={0} >
                <About />
            </CustomTabPanel>

            <CustomTabPanel value={settingTab} index={1}>
            </CustomTabPanel>
        </div>
    )

}
export default Settings